import { getDeviceType } from '~/utils/device'

/** Fires `landing_scanner_click` when the user clicks the scanner CTA in the scan landing section. */
export const trackLandingScannerClick = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		cta_location: content.cta_location,
	}
	LuckyWiseAnalytics.click('landing_scanner_click', params)
}

/** Fires `auth_modal_open` when the authentication modal is opened from the scan section. */
export const trackAuthModalOpen = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		source: content.source,
		tab_name: content.tab_name,
	}

	LuckyWiseAnalytics.click('auth_modal_open', params)
}

/** Fires `auth_success_redirect` when the user is redirected after successful authentication from the scan section. */
export const trackAuthSuccessRedirect = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		source: content.source,
		redirect_destination: content.redirect_destination,
	}

	LuckyWiseAnalytics.click('auth_success_redirect', params)
}

/** Fires `banner_scan_click` when the user clicks the scan promotion banner. */
export const trackBannerScanClick = (content) => {
	const params = {
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
		redirect_destination: content.destination,
	}

	LuckyWiseAnalytics.click('banner_scan_click', params)
}
